import { getAdminSettings, updateAdminSettings } from '../lib/api';
import type { SiteSettings, SiteSettingsFiles, SiteSettingsTextKey } from '../types/siteSettings';

export async function getSiteSettings(): Promise<SiteSettings> {
  return getAdminSettings();
}

export async function updateSiteSettings(
  fields: Partial<Record<SiteSettingsTextKey, string>>,
  files?: SiteSettingsFiles,
): Promise<SiteSettings> {
  return updateAdminSettings(fields, files);
}
